import { http, HttpResponse, type RequestHandler } from 'msw'
import { postCreateUserTokenConfig, postRefreshTokenConfig } from '@services/Auth/api'
import { getApiRoute } from '@core/utils/api'
import { authMock } from '@services/Auth/mocks'

export const postTokenHandler: RequestHandler = http.post(
  getApiRoute(postCreateUserTokenConfig.url),
  () => HttpResponse.json(authMock),
)

export const postRefreshTokenHandler: RequestHandler = http.post(
  getApiRoute(postRefreshTokenConfig.url),
  () => HttpResponse.json({
    token: authMock.token,
  }, {
    headers: {
      'Set-Cookie': 'auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2OTcwMjk3ODcsImV4cCI6MTc2MDEwMTc4NywiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSJ9.isWLca_frlsTJlQnhE4GmgCD9uzSLd4Afn4Yxch8bqY; Path=/; HttpOnly; SameSite=Strict',
    },
  }),
)

export default [
  postTokenHandler,
  postRefreshTokenHandler,
]
